import { render, staticRenderFns } from "./MenuAi.vue?vue&type=template&id=4f63d30c"
import script from "./MenuAi.vue?vue&type=script&lang=js"
export * from "./MenuAi.vue?vue&type=script&lang=js"
import style0 from "./MenuAi.vue?vue&type=style&index=0&id=4f63d30c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports